
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basic-elements/wort-und-bildmarken",
      function () {
        return require("private-next-pages/basic-elements/wort-und-bildmarken.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basic-elements/wort-und-bildmarken"])
      });
    }
  